export default __webpack_public_path__ + "static/media/siteLogo2.fce37564.png";